
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import ScenarioResultsTable from '../scenarios/ScenarioResultsTable';
import { CashflowResult } from '../data/forecastingData';

interface ScenarioComparisonCardProps {
  results: CashflowResult[];
}

const ScenarioComparisonCard: React.FC<ScenarioComparisonCardProps> = ({ results }) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Scenario Comparison</CardTitle>
        <CardDescription>Compare cashflow projections across different scenarios</CardDescription>
      </CardHeader>
      <CardContent>
        <ScenarioResultsTable results={results} />
      </CardContent>
    </Card>
  );
};

export default ScenarioComparisonCard;
